import { UserData } from "01Data/02User/User";
import { AppContext } from "01Data/AppData";
import { BuildingInfo, IFMapImage } from "01Data/DataTypes";
import {
  IFDlgCaller,
  RegisterFormBuilding,
} from "04UserPages/99Parts/CommonDlgs";
import {
  BuildingSection,
  DataDetailDlg,
  DetailForm,
  SensorSection,
} from "97Parts/Andon/AndonSections";
import { MapReader } from "97Parts/MapReader";
import { NoteText } from "97Parts/Styles";
import { useModel, useSignal } from "99Tools/useModel";
import { CheckKizaiID, TypeKizaiKind } from "99Tools/utils";
import { AddCircle } from "@mui/icons-material";
import IconPhotoCamera from "@mui/icons-material/PhotoCamera";
import IconStop from "@mui/icons-material/Stop";
import { LoadingButton } from "@mui/lab";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  styled,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";

const FormDlg = styled("form")(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: "100%", // Fix IE 11 issue.
}));

const ErrorText = styled("div")(({ theme }) => ({
  color: "#f00",
  margin: "0 0 10px",
}));

const ButtonDlg = styled(LoadingButton)(({ theme }) => ({
  margin: theme.spacing(1, 0, 1),
}));

const getCameras = async (data: UserData) => {
  try {
    await data.camera.GetCameras();
    data.andon.changed();
  } catch (error) {
    console.log("カメラ情報取得失敗");
    console.log(error);
  }
};

export const AndonPage = () => {
  const a = useContext(AppContext).account;
  const d = useContext(AppContext).dataUser;
  useModel(d.andon);
  const [bShowDlg, setShowDlg] = useState(false);
  const [bShowDlgBuilding, setShowDlgBuilding] = useState(false);
  const [bShowDlgSensor, setShowDlgSensor] = useState(false);
  // const [bShowDlgPico3, setShowDlgPico3] = useState(false);
  const [dlgData, setDlgData] = useState(new DataDetailDlg());
  const [loading, setLoading] = useState(true);
  const buildingsRedraw = useSignal();
  const sensorsRedraw = useSignal();
  const pico3Redraw = useSignal();

  useEffect(() => {
    d.state = "autoUpdate";
    d.andon
      .Update(a)
      .catch((err: any) => {
        d.andon.SetError(err, "データ取得に失敗しました。");
      })
      .finally(() => {
        setLoading(false);
      });

    return () => {
      d.state = "normal";
    };
  }, [d, a, bShowDlgBuilding, bShowDlgSensor /*bShowDlgPico3*/]);

  const callerBuilding: IFDlgCaller = {
    bShow: () => bShowDlgBuilding,
    close: () => setShowDlgBuilding(false),
    action: async (data: any) => {
      await d.locations.RegisterLocation(
        data.name,
        data.syokenId,
        data.address,
        data.image,
        data.imageExtension
      );
      await d.andon.Update(a);
    },
    redraw: () => d.andon.changed(),
  };

  const handleAddSensor = async () => {
    await getCameras(d);
    setShowDlgSensor(true);
  };

  // const handleAddPico3 = async () => {
  //   await getCameras(d);
  //   setShowDlgPico3(true);
  // };

  return (
    <>
      <BuildingSection
        setShowDlg={setShowDlg}
        setDlgData={setDlgData}
        redraw={buildingsRedraw}
        sensorsRedraw={sensorsRedraw}
        pico3Redraw={pico3Redraw}
      />
      <AddBuildingButton open={() => setShowDlgBuilding(true)} />
      <SensorSection
        setShowDlg={setShowDlg}
        setDlgData={setDlgData}
        redraw={sensorsRedraw}
      />
      <AddSensorButton open={handleAddSensor} />
      {/* <Pico3Section
        setShowDlg={setShowDlg}
        setDlgData={setDlgData}
        redraw={pico3Redraw}
      />
      <AddPico3Button open={handleAddPico3} /> */}
      <DetailForm
        bShowDlg={bShowDlg}
        dlgData={dlgData}
        setShowDlg={setShowDlg}
        buildingsRedraw={buildingsRedraw}
      />
      <RegisterFormBuilding caller={callerBuilding} />
      <RegisterFormDevice
        kind="lte"
        cameraId="cameraLte"
        bShow={() => bShowDlgSensor}
        close={() => setShowDlgSensor(false)}
        redraw={() => d.andon.changed()}
      />
      {/* <RegisterFormDevice
        kind="pico3"
        cameraId="cameraPico"
        bShow={() => bShowDlgPico3}
        close={() => setShowDlgPico3(false)}
        redraw={() => d.andon.changed()}
      /> */}
      <Backdrop open={loading}>
        <CircularProgress sx={{ color: "white" }} />
      </Backdrop>
    </>
  );
};

const AddBuildingButton = ({ open }: { open: () => void }) => {
  const user = useContext(AppContext).account;
  if (user.IsUserManager() || user.IsUserViewer()) {
    // 権限チェック
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: "end", margin: "10px 0" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          component="label"
          variant="contained"
          startIcon={<AddCircle />}
          onClick={open}
        >
          建物追加
        </Button>
      </div>
    </div>
  );
};

const AddSensorButton = ({ open }: { open: () => void }) => {
  const user = useContext(AppContext).account;
  if (user.IsUserViewer()) {
    // 権限チェック
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: "end", margin: "10px 0" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          component="label"
          variant="contained"
          startIcon={<AddCircle />}
          onClick={open}
        >
          漏水みはり番追加
        </Button>
      </div>
    </div>
  );
};

// const AddPico3Button = ({ open }: { open: () => void }) => {
//   const user = useContext(AppContext).account;
//   if (user.IsUserViewer()) {
//     // 権限チェック
//     return null;
//   }

//   return (
//     <div style={{ display: "flex", justifyContent: "end", margin: "10px 0" }}>
//       <div style={{ display: "flex", alignItems: "center" }}>
//         <Button
//           component="label"
//           variant="contained"
//           startIcon={<AddCircle />}
//           onClick={open}
//           sx={{ textTransform: "none" }}
//         >
//           Pico3追加
//         </Button>
//       </div>
//     </div>
//   );
// };

const RegisterFormDevice = ({
  kind,
  cameraId,
  bShow,
  close,
  redraw,
}: {
  kind: TypeKizaiKind;
  cameraId: string;
  bShow: () => boolean;
  close: () => void;
  redraw: () => void;
}) => {
  const account = useContext(AppContext).account;
  const andon = useContext(AppContext).dataUser.andon;
  const d = useContext(AppContext).dataUser;
  const c = useContext(AppContext).dataUser.camera;
  const [buildingId, setBuildingId] = useState("");
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [message, setMesasge] = useState("");
  const [bShowDlgBuilding, setShowDlgBuilding] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileExtension, setFileExtension] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [isReadFromCamera, setIsReadFromCamera] = useState(false);

  useEffect(() => {
    if (isReadFromCamera) {
      const sensor = andon.sensors.find((s: any) => s.SensorId === id);
      if (sensor) {
        setAddress(sensor.LocationName);
        setName(sensor.SensorName);
        setBuildingId(sensor.BuildingId);
      }
      setIsReadFromCamera(false);
    }
  }, [andon, id, isReadFromCamera]);

  class ImageData implements IFMapImage {
    setFileName(name: string): void {
      setFileName(name);
    }
    getFileName(): string {
      return fileName;
    }
    setFileExtension(extension: string): void {
      setFileExtension(extension);
    }
    setData(data: string): void {
      setData(data);
    }
    setError(err: any, message: string): void {
      setMesasge(message);
      console.log(err);
    }
    clear() {
      setFileName("");
      setFileExtension("");
      setData("");
      setMesasge("");
    }
  }

  const handleClose = () => {
    c.CameraOff();
    setId("");
    setBuildingId("");
    setName("");
    setAddress("");
    setMesasge("");
    setFileName("");
    setData("");
    close();
  };

  const handleChangeId = (e: any) => {
    setId(e.target.value);
    setMesasge("");
  };

  const handleChangeBuilding = (e: any) => {
    setBuildingId(e.target.value);
    setMesasge("");
  };

  const handleChangeName = (e: any) => {
    setName(e.target.value);
    setMesasge("");
  };

  const handleChangeAddress = (e: any) => {
    setAddress(e.target.value);
    setMesasge("");
  };

  const handleRegister = async () => {
    if (buildingId === "") {
      setMesasge("建物を選択してください。");
      return;
    }
    if (id === "") {
      setMesasge("機材IDを入力してください。");
      return;
    }
    const kindId = CheckKizaiID(id);
    if (
      (kind === "pico3" && kindId !== "pico3") ||
      (kind === "lte" && kindId !== "lte" && kindId !== "subgiga")
    ) {
      setMesasge("機材IDが不正です。");
      return;
    }
    if (name === "") {
      setMesasge(`${deviceKind}名を入力してください。`);
      return;
    }
    if (kind === "lte" /* lte or subgiga 登録 */) {
      try {
        setLoading(true);
        await d.locations.ResigterSensor(
          id,
          name.replaceAll(`"`, `\\"`),
          buildingId,
          address.replaceAll(`"`, `\\"`),
          data,
          fileExtension
        );
        handleClose();
        andon.Update(account);
      } catch (err) {
        if ((err as Error).message === "すでに存在") {
          setMesasge("デバイスはすでに登録されています。");
        } else if ((err as Error).message === "SIMが存在しない") {
          setMesasge(
            "指定された機材IDは旭光電機のSoracomアカウントに登録されていません。"
          );
        } else if ((err as Error).message === "チェックサム不正") {
          setMesasge("機材IDが不正です。");
        } else if ((err as Error).message === "SIM有効期限未設定") {
          setMesasge("SIMの有効期限が未設定です。");
        } else {
          setMesasge("登録が失敗しました。管理者にご連絡ください。");
        }
        console.log("デバイス登録失敗");
        console.error(err);
      } finally {
        setLoading(false);
      }
    } else if (kind === "pico3") {
      try {
        setLoading(true);
        await d.locations.ResigterPico3(
          id,
          name.replace(`"`, `\\"`),
          buildingId,
          address.replace(`"`, `\\"`),
          data,
          fileExtension
        );
        handleClose();
        andon.Update(account);
      } catch (err) {
        if ((err as Error).message === "すでに存在") {
          setMesasge("デバイスはすでに登録されています。");
        } else {
          setMesasge("登録が失敗しました。管理者にご連絡ください。");
        }
        console.log("デバイス登録失敗");
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeCamera = (e: any) => {
    c.camera = e.target.value;
    c.CameraSwitch(cameraId, setId, setMesasge, setIsReadFromCamera);
    redraw();
  };

  const handleStartCamera = () => {
    c.CameraOn(cameraId, setId, setMesasge, setIsReadFromCamera);
  };

  const handleStopCamera = () => {
    c.CameraOff();
  };

  const callerBuilding: IFDlgCaller = {
    bShow: () => bShowDlgBuilding,
    close: () => setShowDlgBuilding(false),
    action: async (data: any) => {
      await d.locations.RegisterLocation(
        data.name,
        data.syokenId,
        data.address,
        data.image,
        data.imageExtension
      );
      await andon.Update(account);
    },
    redraw: () => andon.changed(),
  };

  const buildingList = andon.buildings
    .sort((a, b) => a.BuildingName.localeCompare(b.BuildingName))
    .map((item: BuildingInfo) => (
      <MenuItem value={item.BuildingId} key={item.BuildingId}>
        <div>{item.BuildingName}</div>
      </MenuItem>
    ));
  const list = c.cameras.map((item: MediaDeviceInfo) => (
    <MenuItem value={item.deviceId} key={item.deviceId}>
      <div>{item.label}</div>
    </MenuItem>
  ));
  const deviceKind =
    kind === "lte" || kind === "subgiga" ? "漏水みはり番" : "Pico3";

  return (
    <>
      <Dialog key="register" open={bShow()}>
        <FormDlg noValidate>
          <DialogTitle>{`${deviceKind}登録`}</DialogTitle>
          <DialogContent>
            <NoteText style={{ marginBottom: "10px" }}>
              各項目を入力してください
            </NoteText>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="dlg_building_label">建物</InputLabel>
              <Select
                labelId="dlg_building_label"
                id="dlg_building_id"
                value={buildingId}
                label="建物"
                onChange={handleChangeBuilding}
              >
                {buildingList.length === 0 ? (
                  <MenuItem value="">
                    <div>なし</div>
                  </MenuItem>
                ) : (
                  buildingList
                )}
              </Select>
            </FormControl>
            <AddBuildingButton open={() => setShowDlgBuilding(true)} />
            <TextField
              variant="filled"
              margin="normal"
              fullWidth
              required
              id="id"
              label="機材ID"
              name="id"
              onChange={handleChangeId}
              value={id}
            />
            <TextField
              variant="filled"
              margin="normal"
              fullWidth
              required
              id="name"
              label={`${deviceKind}名`}
              name="name"
              onChange={handleChangeName}
              inputProps={{ maxLength: 128 }}
              value={name}
            />
            <TextField
              variant="filled"
              margin="normal"
              fullWidth
              id="address"
              label="設置場所名"
              name="address"
              onChange={handleChangeAddress}
              inputProps={{ maxLength: 128 }}
              value={address}
            />
            <MapReader entity={new ImageData()} redraw={() => {}} />
            {message !== "" ? <ErrorText>{message}</ErrorText> : null}
            <FormControl
              fullWidth
              variant="outlined"
              style={{ marginTop: "10px" }}
            >
              <InputLabel id="dlg_contact_kind_label">カメラ</InputLabel>
              <Select
                labelId="dlg_contact_kind_label"
                id="dlg_contact_kind"
                value={c.camera}
                label="カメラ"
                onChange={handleChangeCamera}
              >
                {list.length === 0 ? (
                  <MenuItem value="">
                    <div>なし</div>
                  </MenuItem>
                ) : (
                  list
                )}
              </Select>
            </FormControl>
            <video
              className={cameraId}
              style={{ width: "100%", maxWidth: "1000px", marginTop: "1em" }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <ButtonDlg
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleStartCamera}
              >
                <IconPhotoCamera />
              </ButtonDlg>
              <ButtonDlg
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleStopCamera}
              >
                <IconStop />
              </ButtonDlg>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <ButtonDlg
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleRegister}
                loading={loading}
              >
                確定
              </ButtonDlg>
              <ButtonDlg
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleClose}
              >
                キャンセル
              </ButtonDlg>
            </div>
          </DialogContent>
        </FormDlg>
      </Dialog>
      <RegisterFormBuilding caller={callerBuilding} />
    </>
  );
};
